import React, { Fragment, ReactNode, useRef, useState } from 'react';

interface ImageProps {
    src?: string;
    alt?: string;
    style?: React.CSSProperties;
    altImage?: ReactNode;
    loadImage?: ReactNode;
    onLoad?: (...args: any[]) => void;
    [key: string]: any;
}

interface ImageState {
    loaded: boolean;
    error?: boolean;
}

const Image = (props: ImageProps) => {
    const [state, setState] = useState<ImageState>({loaded: false});

    // Mirrors the class's shouldComponentUpdate: when src changes, reset the
    // loaded/error flags before rendering. Adjusting state during render with a
    // prev-value ref is React's supported equivalent and stays synchronous.
    const prevSrc = useRef(props.src);
    if(prevSrc.current !== props.src){
        prevSrc.current = props.src;
        setState({loaded: false, error: false});
    }

    var {altImage, loadImage, onLoad, ...otherProps} = props;
    if(state.error && altImage){
        return altImage;
    }
    return <Fragment>
        {!state.loaded && loadImage ? <Fragment>{loadImage}</Fragment> : ''}
        <img {...otherProps} alt={props.alt} style={{...props.style, display: state.error || !state.loaded ? 'none' : undefined}} onLoad={() => {setState(prev => ({...prev, loaded: true})); if(props.onLoad){props.onLoad()}}} onError={() => setState(prev => ({...prev, error: true}))}/>
        </Fragment>;
};

export default Image;
